import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import Footer from './components/Footer.js';
import Logo from './components/Logo.js';
import Downloads from './components/Downloads';

ReactDOM.render(
  <React.StrictMode>
    <Logo />
    <Router>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/downloads" element={<Downloads />} />
      </Routes>
    </Router>
    <Footer />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
